<template>
  <div class="card  border-secondary">
    <div class="card-body">

        <div class="row" v-if="cupomData.length > 0 || cupom_selecionado">
          <div class="col-12">
            <div class="row">
              <div class="col-6">Subtotal:</div>
              <div class="col-6 text-right">{{ formatarValorMonetario(subTotal) }}</div>
            </div>
          </div>
          <div class="col-12 mt-2 mb-2">
            <div class="row">
              <div class="col-6">Desconto:</div>
              <div class="col-6 text-right">{{ formatarValorMonetario(desconto) }}</div>
            </div>
          </div>
        </div>
      <span class="card-text text-muted">Total:</span>
      <span class="card-text float-right text-bold">{{formatarValorMonetario(totalBruto)}}</span>
    </div>
  </div>
</template>
<script>
import util from '@/util'
import constants from '@/util/constants'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Total',
  components: {
  },
  props: {
    total: {
      type: [Number, String],
      default: 0
    },
    cupom_selecionado: {
      type: Object,
      default: null
    },
    pedidos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('carrinho', ['cupomData', 'itens'])
  },
  data: () => {
    return {
      subTotal: 0,
      desconto: 0,
      totalBruto: 0,
      valorPlanoComDesconto: 0
    }
  },
  watch: {
    total (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.atualizarPrecos()
      }
    },
    itens (newVal) {
      this.ActionLimparCupomDataDoCarrinho()
    },
    cupomData (newVal) {
      this.atualizarPrecos()
    }
  },
  mounted () {
    if (this.pedidos.length > 0) { // Quando já esta na parte de contratacao.
      this.pedidos.forEach(pedido => {
        this.subTotal += this.obterTotalPorPedido(pedido)

        if (pedido.cupom_aplicado) {
          this.valorPlanoComDesconto = this.obterTotalPorPedido(pedido)
        }
      })
      this.desconto = (this.subTotal - this.total)
      this.totalBruto = (this.subTotal - this.desconto)
    } else {
      this.totalBruto = this.total
      this.subTotal = this.total
      this.desconto = 0
      this.atualizarPrecos()
    }
  },
  methods: {
    ...mapActions('carrinho', [
      'ActionDefinirCupomDataDoCarrinho',
      'ActionLimparCupomDataDoCarrinho'
    ]),
    obterTotalPorPedido (pedido) {
      return pedido.valor * pedido.quantidade
    },
    atualizarPrecos () {
      this.totalBruto = this.total
      this.subTotal = this.total
      this.desconto = 0

      if (this.cupomData.length > 0) { // Aqui quando o carrinho ainda nao foi para parte de contratar e ele faz um calculo sem o proporcional
        const cupomData = JSON.parse(this.cupomData)
        if (cupomData && cupomData !== 'null' && cupomData.plano === null) {
          if (cupomData.tipo === constants.tipoMonetario) {
            this.desconto = cupomData.valor
          } else if (cupomData.tipo === constants.tipoPercentual) {
            this.desconto = (cupomData.valor / 100) * this.total
          }
          this.totalBruto = (this.total - this.desconto)
        } else if (cupomData && cupomData !== 'null' && cupomData.plano !== null) {
          const itemComDesconto = this.itens.filter(item => item.produto.plano.id === cupomData.plano)
          if (cupomData.tipo === constants.tipoMonetario) {
            this.desconto = cupomData.valor

            if (parseFloat(cupomData.valor) > parseFloat(itemComDesconto[0].produto.plano.valor)) {
              this.desconto = itemComDesconto[0].produto.plano.valor
            }
          } else if (cupomData.tipo === constants.tipoPercentual) {
            this.desconto = (itemComDesconto[0].produto.plano.valor * (cupomData.valor / 100)) * itemComDesconto[0].produto.quantidade
          }
          this.totalBruto = (this.total - this.desconto)
        }
      }

      if (this.desconto > this.subTotal) {
        this.desconto = this.subTotal
      }

      if (this.totalBruto <= 0) {
        this.totalBruto = 0
      }
    },
    formatarValorMonetario (valor, tipo = constants.tipoMonetario, total, desconto = false) {
      if (util.valorEhNulo(valor)) {
        return 'R$ 0'
      }
      if (tipo === constants.tipoMonetario) {
        return util.formatarValorMonetarioComCifrao(valor)
      } else if (tipo === constants.tipoPercentual) {
        // Converter percentual para valor monetário usando regra de três
        let valorConvertido = (valor / 100) * total

        if (this.valorPlanoComDesconto > 0 && desconto) {
          valorConvertido = (valor / 100) * this.valorPlanoComDesconto
        }

        return util.formatarValorMonetarioComCifrao(valorConvertido)
      }
    }
  }
}
</script>
